import { render, staticRenderFns } from "./arch.vue?vue&type=template&id=afb20168&"
import script from "./arch.vue?vue&type=script&lang=js&"
export * from "./arch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports